export default __webpack_public_path__ + "static/media/nft5.990b363f.jpg";